import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { ApplicationState, store } from "./state";

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<ApplicationState> = useSelector;
